import AccessGroupsChipList from './AccessGroupsChipList';

export default AccessGroupsChipList;
